import { z } from 'zod';

// Occupation Configuration Transfer Import/Export schemas

const occupationCTExportDataSchema = z
    .object({
        groupId: z.string().optional(),
        reportId: z.string().optional(),
        functionId: z.string().optional(),
        credentials: z
            .object({
                credentialId: z.string().optional(),
                jasBoardId: z.string().optional(),
            })
            .passthrough()
            .array()
            .optional(),
    })
    .passthrough();

export type OccupationCTExportData = z.infer<typeof occupationCTExportDataSchema>;

export const occupationCTExportSchema = occupationCTExportDataSchema
    .merge(z.object({ default: occupationCTExportDataSchema.optional() }))
    .passthrough();

export type OccupationCTExport = z.infer<typeof occupationCTExportSchema>;

const occupationCTImportDataSchema = z
    .object({
        groupName: z.string().optional(),
        reportName: z.string().optional(),
        functionName: z.string().optional(),
        credentials: z
            .object({
                credentialName: z.string().optional(),
                jasBoardName: z.string().optional(),
            })
            .passthrough()
            .array()
            .optional(),
    })
    .passthrough();

export type OccupationCTImportData = z.infer<typeof occupationCTImportDataSchema>;

export const occupationCTImportSchema = occupationCTImportDataSchema
    .merge(z.object({ default: occupationCTImportDataSchema.optional() }))
    .passthrough();

// Professional Status Configuration Transfer Import/Export schemas

const professionalStatusCTExportDataSchema = z
    .object({
        occupationGroupIds: z.string().array().optional(),
    })
    .passthrough();

export type ProfessionalStatusCTExportData = z.infer<typeof professionalStatusCTExportDataSchema>;

export const professionalStatusCTExportSchema = professionalStatusCTExportDataSchema
    .merge(z.object({ default: professionalStatusCTExportDataSchema.optional() }))
    .passthrough();

export type ProfessionalStatusCTExport = z.infer<typeof professionalStatusCTExportSchema>;

const professionalStatusCTImportDataSchema = z
    .object({
        occupationGroupNames: z.string().array().optional(),
    })
    .passthrough();

export type professionalStatusCTImportData = z.infer<typeof professionalStatusCTImportDataSchema>;

export const professionalStatusCTImportSchema = professionalStatusCTImportDataSchema
    .merge(z.object({ default: professionalStatusCTImportDataSchema.optional() }))
    .passthrough();
